/**
 * Calculates the difference in minutes between two Date objects.
 * @param fromDate - Start date/time
 * @param toDate - End date/time
 * @returns Total difference in minutes
 */
export function getSecondsDifference(
  fromDate: Date,
  toDate: Date
): number {
  const diffMilliseconds = toDate.getTime() - fromDate.getTime();
  const diffHours = Math.floor(diffMilliseconds / (1000 * 60 * 60));
  const diffMinutes = Math.floor(
    (diffMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
  );
  // Convert total hours and minutes to minutes
  return diffHours * 60 + diffMinutes;
}
